import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import './choose-menu.css';
import { pageAction } from '../../redux_files/actions/page_actions';
import { PHONE_NUMBER_WITH_PREFIX } from '../../utils/constants';
import FOOD_ITEMS from './data/food-items';
import SelectItems from './components/select-items';

// Step component for selecting food items
function FoodItemSelectorStep({ error, setError, isFirstStep, isLastStep, onSelectionChange }) {
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    if (onSelectionChange) onSelectionChange(selectedItems);
  }, [selectedItems, onSelectionChange]);

  // Calculate total
  const total = selectedItems.reduce((sum, item) => {
    const food = FOOD_ITEMS.find(f => f.name === item.name);
    return sum + (food ? food.price * item.quantity : 0);
  }, 0);

  return (
    <div>
      <SelectItems
        items={FOOD_ITEMS}
        selectedItems={selectedItems}
        onChange={setSelectedItems}
      />
      {error && <div className="error-message">{error}</div>}
      {selectedItems.length > 0 && (
        <div className="order-summary-bar">
          <div style={{fontWeight: 600, marginBottom: 6}}>Order Summary</div>
          <ul style={{margin: 0}}>
            {selectedItems.map(item => {
              const food = FOOD_ITEMS.find(f => f.name === item.name);
              return (
                <li key={item.name} style={{marginBottom: 4, fontSize: '1rem', padding: '0px', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                  <span>
                    {item.name} <span style={{color:'#888'}}>x{item.quantity}</span>
                  </span>
                  <span style={{display: 'flex', alignItems: 'center'}}>
                    <span style={{fontWeight: 500, marginRight: 12}}>₹{food ? food.price * item.quantity : 0}</span>
                    <button
                      style={{background: 'none', border: 'none', color: '#eb6c20', fontSize: '1.2em', cursor: 'pointer', padding: 0, marginLeft: 4, display: 'flex', alignItems: 'center'}}
                      title="Remove item"
                      onClick={() => setSelectedItems(selectedItems.filter(i => i.name !== item.name))}
                    >
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 7V15C6 15.5523 6.44772 16 7 16H13C13.5523 16 14 15.5523 14 15V7" stroke="#eb6c20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M4 7H16" stroke="#eb6c20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M8 7V13" stroke="#eb6c20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 7V13" stroke="#eb6c20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9 4H11C11.5523 4 12 4.44772 12 5V5C12 5.55228 11.5523 6 11 6H9C8.44772 6 8 5.55228 8 5V5C8 4.44772 8.44772 4 9 4Z" stroke="#eb6c20" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  </span>
                </li>
              );
            })}
          </ul>
          <div className="order-total-bar" style={{marginTop: 8, display: 'flex', justifyContent: 'space-between', fontWeight: 600, fontSize: '1.1rem'}}>
            <span>Order Total</span>
            <span>₹{total}</span>
          </div>
        </div>
      )}
    </div>
  );
}

const steps = [
  {
    label: 'Select Food Items',
    component: (props) => <FoodItemSelectorStep {...props} onSelectionChange={props.onSelectionChange} />,
  },
  // Add more steps as needed
];
const ChooseYourMenu = () => {
  const dispatch = useDispatch();
  const [currentStep, setCurrentStep] = useState(0);
  const [error, setError] = useState('');
  const [selectedItems, setSelectedItems] = useState([]); // For order total
  // const [deviceType, setDeviceType] = useState(getDeviceType());
  const StepComponent = steps[currentStep].component;
  useEffect(() => {
    document.title = 'Choose Your Menu';
    dispatch(pageAction('Choose Your Menu'));
  });
  // useEffect(() => {
  //     window.addEventListener('resize', setDeviceType(getDeviceType()));
  //     return () => window.removeEventListener('resize', setDeviceType(getDeviceType()));
  // }, []);

  const handleNext = () => {
    // Validation for food item selection step
    if (currentStep === 0) {
      if (!selectedItems || selectedItems.length === 0) {
        setError('Please select at least one food item.');
        return;
      }
      setError('');
    }
    setCurrentStep((prev) => prev + 1);
  };
  const handlePrev = () => {
    setCurrentStep((prev) => prev - 1);
  };


  return (
    <div className="step-main-container pd-15">
      <div className="step-inner-container">
        <div className="steps-bar">
          <div
            key={steps[currentStep].label}
            className="step-label-new"
          >
            {steps[currentStep].label}
          </div>
        </div>
        <StepComponent
          error={error}
          setError={setError}
          isFirstStep={currentStep === 0}
          isLastStep={currentStep === steps.length - 1}
          onSelectionChange={setSelectedItems}
        />
      </div>

      {/* Navigation Buttons outside the card */}
      <div className="buffet-button-container">
        {currentStep > 0 && (
          <button
            className="primary-button buffet-step-button"
            onClick={handlePrev}
            type="button"
          >
            Previous
          </button>
        )}
        {currentStep === steps.length - 1 ? (
          <a
            href={`tel:${PHONE_NUMBER_WITH_PREFIX}`}
            className="primary-button buffet-step-button"
            style={{ textAlign: 'center', textDecoration: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            Click to book
          </a>
        ) : (
          <button
            className="primary-button buffet-step-button"
            onClick={handleNext}
            type="button"
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default ChooseYourMenu;
